import { Heading, Paragraph } from '@zillow/constellation';
import type { Answers } from '../../../../../graphql/queries';
import { getAnswersForFields } from '../../../../../utils/overview/overview-display';
import { FIELD_IDS } from '../../../../../constants/wizard';
import { formatDate, getFormattedAddress, getPhoneNumberScreenFormat } from '../../../../../utils/formatters';

interface Props {
  answers: Answers;
}

const fieldsInStep = [
  FIELD_IDS.CURRENT_RESIDENCE_AMOUNT,
  FIELD_IDS.CURRENT_RESIDENCE_CITY,
  FIELD_IDS.CURRENT_RESIDENCE_DESCRIPTION,
  FIELD_IDS.CURRENT_RESIDENCE_MANAGER_EMAIL,
  FIELD_IDS.CURRENT_RESIDENCE_MANAGER_NAME,
  FIELD_IDS.CURRENT_RESIDENCE_MANAGER_PHONE,
  FIELD_IDS.CURRENT_RESIDENCE_START_DATE,
  FIELD_IDS.CURRENT_RESIDENCE_STATE,
  FIELD_IDS.CURRENT_RESIDENCE_STREET,
  FIELD_IDS.CURRENT_RESIDENCE_ZIP,
  FIELD_IDS.REASON_FOR_MOVING,
];

export function CurrentResidenceOverview({ answers }: Props) {
  const answersForFields = getAnswersForFields({ fieldIds: fieldsInStep, answers });

  const formattedAddress = getFormattedAddress({
    city: answersForFields[FIELD_IDS.CURRENT_RESIDENCE_CITY] as string,
    state: answersForFields[FIELD_IDS.CURRENT_RESIDENCE_STATE] as string,
    street: answersForFields[FIELD_IDS.CURRENT_RESIDENCE_STREET] as string,
    zip: answersForFields[FIELD_IDS.CURRENT_RESIDENCE_ZIP] as string,
  });

  return (
    <>
      {formattedAddress && (
        <>
          <Heading level={6} marginY="xs">
            Address
          </Heading>
          <Paragraph>{formattedAddress}</Paragraph>
        </>
      )}
      {answersForFields[FIELD_IDS.CURRENT_RESIDENCE_START_DATE] && (
        <>
          <Heading level={6} marginY="xs">
            Lived here since
          </Heading>
          <Paragraph>{formatDate(answersForFields[FIELD_IDS.CURRENT_RESIDENCE_START_DATE] as string)}</Paragraph>
        </>
      )}
      {answersForFields[FIELD_IDS.CURRENT_RESIDENCE_AMOUNT] && (
        <>
          <Heading level={6} marginY="xs">
            Monthly payment amount
          </Heading>
          <Paragraph>{answersForFields[FIELD_IDS.CURRENT_RESIDENCE_AMOUNT]}</Paragraph>
        </>
      )}
      {answersForFields[FIELD_IDS.REASON_FOR_MOVING] && (
        <>
          <Heading level={6} marginY="xs">
            Reason for moving
          </Heading>
          <Paragraph>{answersForFields[FIELD_IDS.REASON_FOR_MOVING]}</Paragraph>
        </>
      )}
      {(answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_NAME] ||
        answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_EMAIL] ||
        answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_PHONE]) && (
        <>
          <Heading level={6} marginY="xs">
            Landlord contact info
          </Heading>
          {answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_NAME] && (
            <Paragraph>{answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_NAME]}</Paragraph>
          )}
          {answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_EMAIL] && (
            <Paragraph>{answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_EMAIL]}</Paragraph>
          )}
          {answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_PHONE] && (
            <Paragraph>
              {getPhoneNumberScreenFormat(answersForFields[FIELD_IDS.CURRENT_RESIDENCE_MANAGER_PHONE] as string)}
            </Paragraph>
          )}
        </>
      )}
      {answersForFields[FIELD_IDS.CURRENT_RESIDENCE_DESCRIPTION] && (
        <>
          <Heading level={6} marginY="xs">
            Description
          </Heading>
          <Paragraph>{answersForFields[FIELD_IDS.CURRENT_RESIDENCE_DESCRIPTION]}</Paragraph>
        </>
      )}
    </>
  );
}
